module.exports = __webpack_public_path__ + "static/media/resumen_Plan.54bf4e5a.png";